// extracted by mini-css-extract-plugin
export default {"dialogPaper":"AddEditScenarioDialog_dialogPaper__EM73f","content":"AddEditScenarioDialog_content__81rWc"};